import { useEffect, useState } from "react";
import { Footer } from "../components/footer";
import { Header } from "../components/header";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify";
import { trackEvent, trackPageView } from "../utils/segment";

export const Community = () => {
  const [spotifyPlaylists, setSpotifyPlaylists] = useState([]);
  const [instagramPosts, setInstagramPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    trackPageView("Entered Community Page");
    fetchMediaData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchMediaData = async () => {
    try {
      setLoading(true);
      const [instagram, spotify] = await Promise.all([
        // getLatestTikTokPost(),
        getLatestInstagramPost(),
        getSpotifyPlaylists(),
      ]);
      setSpotifyPlaylists(spotify.splice(0, 5));
      setInstagramPosts(instagram.splice(0, 6));
      setLoading(false);
    } catch (error) {
      toast.error("Unfortunately, an error occured when fetching playlists");
      setLoading(false);
    }
  };

  // const getLatestTikTokPost = async () => {
  //   const username = "adekunlegold";
  //   try {
  //     const url = `https://www.tiktok.com/@${username}?lang=en`;
  //     const response = await axios.get(url, {
  //       headers: {
  //         "User-Agent": "Mozilla/5.0", // Helps avoid bot detection
  //       },
  //     });

  //     const videoUrls = response.data.match(/"playAddr":"(.*?)"/g);
  //     if (videoUrls && videoUrls.length > 0) {
  //       const latestVideoUrl = videoUrls[0]
  //         .replace(/"playAddr":"/, "")
  //         .replace(/"/, "");
  //       console.log({ latestVideoUrl });
  //       return `https:${latestVideoUrl}`;
  //     } else {
  //       throw new Error("No videos found");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching latest TikTok post:", error.message);
  //     return null;
  //   }
  // };

  const getLatestInstagramPost = async () => {
    try {
      const url = `https://qn6x4esklh.execute-api.us-east-1.amazonaws.com/prod/ig/posts`;
      // const url = "http://api.tradedepot.co/services/ig/posts";
      const response = await axios.get(url);
      return response.data; // List of user's posts
    } catch (error) {
      console.error(
        "Error fetching Instagram feeds:",
        error.response?.data || error.message
      );
      return null;
    }
  };

  const getSpotifyPlaylists = async () => {
    try {
      const {
        data: { access_token },
      } = await axios.post(
        "https://accounts.spotify.com/api/token",
        {
          grant_type: "client_credentials",
          client_id: process.env.REACT_APP_SPOTIFY_CLIENT_ID,
          client_secret: process.env.REACT_APP_SPOTIFY_CLIENT_SECRET,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      const {
        data: { items },
      } = await axios.get(
        "https://api.spotify.com/v1/users/31lfejx4ccbvlj3my2bqfqccgwmu/playlists",
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return items; // List of playlists
    } catch (error) {
      console.error(
        "Error fetching playlists:",
        error.response?.data || error.message
      );
      return null;
    }
  };

  return (
    <>
      <Header />
      <div className="container-fluid community-container">
        <h5>Join the celebration</h5>
        <div className="sc-container">
          <div className="sc">
            <div className="title">
              <div className="icon">
                <i className="bi bi-instagram"></i>
              </div>
              <h6>Instagram</h6>
            </div>
            <div className="sc-content instagram">
              {loading ? (
                <div className="loading-container">
                  {[1, 2, 3, 4, 5, 6, 3, 2, 3, 2].map((_, key) => (
                    <Skeleton height={90} width={100} key={key} count={1} />
                  ))}
                </div>
              ) : (
                <div className="flex-posts">
                  {[...instagramPosts].map((post) => (
                    <a
                      className="post"
                      href={post.permalink}
                      key={post.id}
                      target="_blank"
                      rel="noreferrer"
                      onClick={() =>
                        trackEvent("Instagram Post Clicked", {
                          instagramPostLink: post.permalink,
                        })
                      }
                    >
                      <img
                        src={post.media_url}
                        alt="instagram"
                        className="img-fluid"
                      />
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="sc">
            <div className="title">
              <div className="icon">
                <i className="bi bi-tiktok"></i>
              </div>
              <h6>TikTok</h6>
            </div>
            <div className="sc-content tiktok">
              {loading ? (
                <div className="loading-container">
                  <Skeleton height="500px" count={1} />
                </div>
              ) : (
                <div className="">
                  {/* <img src={instagram.media_url} alt="instagram" />
                  <p>{instagram.caption}</p> */}
                </div>
              )}
            </div>
          </div>
          <div className="sc">
            <div className="title">
              <div className="icon">
                <i className="bi bi-spotify"></i>
              </div>
              <h6>Amabile Vibes</h6>
            </div>
            <div className="sc-content playlist">
              <br />
              {loading ? (
                <>
                  <Skeleton height={70} count={1} />
                  <br />
                  <Skeleton height={70} count={1} />
                  <br />
                  <Skeleton height={70} count={1} />
                </>
              ) : (
                spotifyPlaylists.map((item, key) => (
                  <a
                    className="playlist-item"
                    href={item.external_urls.spotify}
                    key={key}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      trackEvent("Spotify Playlist Clicked", {
                        instagramPostLink: item.external_urls.spotify,
                      })
                    }
                  >
                    <div className="icon-holder">
                      <i className="bi bi-play-fill"></i>
                    </div>
                    <div className="playlist-item-content">
                      <h6>{item.name}</h6>
                      <h4>{item.description}</h4>
                    </div>
                  </a>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
